import { generateConfig } from "./gs-utils/core/utils";
import { API_URL_CONFIG_TYPE } from "./gs-utils/core/types";

interface configType {
  protocol: string,
  openapi: string,
  apiGetway: string,
  refreshToken: string,
  prefix: string,
  iam: string,
  applications: string,
  robot: string,
  dataCenter: string,
  myProfile: string,
}
const { homeUrl, bot:domain, serviceUrl, openapi, apiGetway } = generateConfig() as API_URL_CONFIG_TYPE;

const applicationCenterProfile = `${window.location.origin}/iam#/app/personal-data`;

export const envConfig : configType =  {
  protocol: 'https://',
  apiGetway,
  openapi: openapi.slice(8),
  prefix: serviceUrl,
  iam: `${serviceUrl}/iam`,
  applications: `${homeUrl}`,
  dataCenter: `${serviceUrl}/data-center`,
  robot: `${serviceUrl}`,
  refreshToken: `${domain}/gas/api/v1alpha1/auth/token`,
  myProfile: applicationCenterProfile,
}